/// <amd-module name="CodeCoverage/CodeCoverageCiTab/Components/Constants" />
export const DonutChartColorMap = {
    Covered: "#269624",
    Missed: "#B31B1B"
};
